import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useMcpExamples = (config) => {
  return useQuery({
    ...config,
    queryKey: "industries",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/mcp-examples`,
        signal,
      }),
  });
};
